export const ABOUT_CONSTS = {
    GET_ABOUT_SLIDERS: "GET_ABOUT_SLIDERS",
    CREATE_ABOUT_SLIDER: "CREATE_ABOUT_SLIDER",
    UPDATE_ABOUT_SLIDERS_POSITIONS: "UPDATE_ABOUT_SLIDERS_POSITIONS",
    UPDATE_ABOUT_SLIDER_BY_ID: "UPDATE_ABOUT_SLIDER_BY_ID",
    DELETE_ABOUT_SLIDER_BY_ID: "DELETE_ABOUT_SLIDER_BY_ID",

    SET_ABOUT_DATA:"SET_ABOUT_DATA",
};
